import * as styles from './custom-option.module.css';

import React from 'react';
import { components } from 'react-select';

export function CustomOption(props) {
	const { address, selectProps, data, isSelected, label } = props;
	const { useCheckbox } = selectProps || {};

	const addressData = data?.value?.structured_formatting;
	const addressMainText = addressData?.main_text;
	const addressSecondaryText = addressData?.secondary_text;

	return (
		<div className={styles.container}>
			<components.Option {...props}>
				{useCheckbox && (
					<>
						<input
							type='checkbox'
							checked={isSelected}
							onChange={() => null}
						/>
						<span className={styles.almaCheckboxIcon} />
					</>
				)}
				<label>
					{address ? (
						<div className={styles.addressContent}>
							<p className={styles.addressMain}>
								{addressMainText}
							</p>
							<p className={styles.addressSecondary}>
								{addressSecondaryText}
							</p>
						</div>
					) : (
						label
					)}
				</label>
			</components.Option>
		</div>
	);
}
